import React, { useState, useEffect, useRef } from "react";
import "./UserHeader.css";

const UserHeader = ({ onLogout }) => {
    const [showUserMenu, setShowUserMenu] = useState(false);
    const userName = localStorage.getItem("username") || "Utente";
    const role = localStorage.getItem("role") || "user";
    const dropdownRef = useRef(null);

    const getRoleName = (role) => {
        switch(role) {
            case "admin": return "Amministratore";
            case "officina": return "Officina";
            case "abiti": return "Abiti";
            case "gestore_magazzino": return "Gestore Magazzino";
            default: return "Utente";
        }
    };

    const getUserInitials = (name) => {
        return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowUserMenu(false);
            }
        };

        if (showUserMenu) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showUserMenu]);

    return (
        <div className="user-info-container" ref={dropdownRef}>
            <div
                className="user-info"
                onClick={() => setShowUserMenu(!showUserMenu)}
            >
                <div className="user-details">
                    <div className="user-name">{userName}</div>
                    <div className="user-role">{getRoleName(role)}</div>
                </div>
                <div className="user-avatar">{getUserInitials(userName)}</div>
            </div>
            {showUserMenu && (
                <div className="user-dropdown">
                    <button className="logout-dropdown-btn" onClick={(e) => {
                        e.stopPropagation();
                        onLogout();
                    }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                        </svg>
                        Logout
                    </button>
                </div>
            )}
        </div>
    );
};

export default UserHeader;
